import React from 'react'
import CardServicio1 from '../ServiciosCard/CardServicio1'
import CardServicio2 from '../ServiciosCard/CardServicio2'
import CardServicio3 from '../ServiciosCard/CardServicio3'


const Servicios = () => {
    return (
        <section id='servicios' className="ds-section">
            <div className="ds-section-bg"></div>
            <div className="container py-5 position-relative">
                <div className="row justify-content-center text-center mb-5">
                    <div className="col-10 col-md-8">
                        <span className="ds-eyebrow">Servicios</span>
                        <h2 className="text-white mt-2 mb-3 ds-titulo">
                            ¿Qué hacemos en <span className="ds-highlight">Dscode</span>?
                        </h2>
                        <p className="ds-lead mb-0">Tres soluciones pensadas para tu etapa: empezar, vender o escalar.</p>
                    </div>
                </div>
                <div className="row justify-content-evenly pb-3 pt-3">
                    <CardServicio1 />
                    <CardServicio2 />
                    <CardServicio3 />
                </div>
            </div>
        </section>
    )
}

export default Servicios
